import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import readyToExpImg from './images/ready-to-exp.png';

const useStyles = makeStyles((theme) => ({
  ctaSection: {
    maxWidth: 1314,
    margin: '80px auto 10px',
    padding: '60px 0px 0',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#0a0a0a',
      margin: '0 auto 10px',
      padding: '10px 16px 0',
    },
  },
  ctaContainer: {
    background: 'linear-gradient(90deg, #ce949c 0%, #e6b1bd 25%, #ffd0e1 55%, #ce949c 100%)',
    borderRadius: 16,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 60px',
    position: 'relative',
    height: 326,
    maxHeight: 326,
    overflow: 'visible',
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      padding: '0 40px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: '25px 24px 0',
      textAlign: 'center',
      height: 'auto',
      maxHeight: 'none',
      overflow: 'hidden',
    },
  },
  ctaContent: {
    maxWidth: 700,
    zIndex: 2,
    padding: 0,
    [theme.breakpoints.down('md')]: {
      maxWidth: 520,
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
      padding: '0 0 20px 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  ctaTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: '52px',
    fontWeight: 400,
    lineHeight: '100%',
    letterSpacing: '0%',
    color: '#111111',
    marginBottom: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '36px',
      width: '95%',
    },
  },
  ctaSubtitle: {
    fontFamily: '"Roboto", sans-serif',
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '27px',
    color: '#0C0A09',
    marginBottom: '24px',
    maxWidth: 520,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
      lineHeight: '21px',
      textAlign: 'center',
    },
  },
  buttonRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      width: '100%',
      gap: '12px',
    },
  },
  btnMember: {
    backgroundColor: '#fd3c84',
    color: '#ffffff',
    padding: '12px 28px',
    height: 48,
    borderRadius: 6,
    fontSize: '16px',
    fontWeight: 600,
    border: 'none',
    fontFamily: '"Roboto", sans-serif',
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(253, 60, 132, 0.3)',
    transition: 'transform 0.2s, background-color 0.2s',
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: '#ff4081',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 28px',
      height: 38,
      width: '100%',
      maxWidth: 280,
      textAlign: 'center',
      fontSize: '16px',
      lineHeight: '100%',
      textTransform: 'capitalize',
    },
  },
  btnCreator: {
    backgroundColor: 'transparent',
    color: '#fd3c84',
    padding: '12px 28px',
    borderRadius: 6,
    fontSize: '16px',
    height: 48,
    fontWeight: 600,
    border: '1px solid #fd3c84',
    fontFamily: '"Roboto", sans-serif',
    cursor: 'pointer',
    transition: 'transform 0.2s, background-color 0.2s',
    '&:hover': {
      transform: 'translateY(-1px)',
      backgroundColor: 'rgba(253, 60, 132, 0.08)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 28px',
      height: 38,
      width: '100%',
      maxWidth: 280,
      textAlign: 'center',
      fontSize: '16px',
      lineHeight: '100%',
      textTransform: 'capitalize',
    },
  },
  ctaImageContainer: {
    position: 'absolute',
    right: 40,
    bottom: 0,
    height: 380,
    zIndex: 3,
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    [theme.breakpoints.down('md')]: {
      height: 340,
      right: 20,
    },
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
      right: 0,
      width: '100%',
      height: 240,
      marginTop: 10,
      justifyContent: 'center',
    },
  },
  ctaImage: {
    height: 380,
    width: 'auto',
    objectFit: 'contain',
    objectPosition: 'bottom right',
    display: 'block',
    verticalAlign: 'bottom',
    [theme.breakpoints.down('md')]: {
      height: 340,
    },
    [theme.breakpoints.down('sm')]: {
      height: 240,
      objectPosition: 'bottom center',
    },
  },
}));

export const VirtualCompanionshipJourneyCTASection = () => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Box className={classes.ctaSection}>
      <Box className={classes.ctaContainer}>
        <Box className={classes.ctaContent}>
          <Typography className={classes.ctaTitle}>
            Ready to Experience<br />
            Premium Connections?
          </Typography>
          <Typography className={classes.ctaSubtitle}>
            Whether you're looking to connect with creators or become one, your journey starts here.
          </Typography>

          <Box className={classes.buttonRow}>
            <button
              className={classes.btnMember}
              onClick={() => history.push('/member-onboarding-step')}
            >
              Request Member Access
            </button>
            <button
              className={classes.btnCreator}
              onClick={() => history.push('/apply-as-creator')}
            >
              Apply As Creator
            </button>
          </Box>
        </Box>

        <Box className={classes.ctaImageContainer}>
          <img
            src={readyToExpImg}
            alt="Ready to Experience Premium Connections"
            className={classes.ctaImage}
          />
        </Box>
      </Box>
    </Box>
  );
};

